import type { IconData } from '@stacksjs/iconify-core'

export const batteryEmpty: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21 14a1 1 0 0 1-1-1v-2a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1m-4 3H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default batteryEmpty
